import styled from 'styled-components';

export default styled.section<{ purchasePage: boolean }>`
  display: flex;
  flex-direction: column;
  margin: auto 0;
`;
